module.exports = __webpack_public_path__ + "static/media/SET-101-badge.ed17a748.svg";